(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('FileContent', FileContent);

    FileContent.$inject = ['$resource'];

    function FileContent ($resource) {
        var resourceUrl =  'api/file-contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
